module.exports = __webpack_public_path__ + "static/empilhadeira-d841f8635743d1f96b2a5d7ec5e37c9f.jpg";